import {
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { LocalStorageCacheService } from 'src/app/service/storage/auth/local-storage-cache.service';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { AfterViewInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  continents = new Map<String, any>();
  navBarShown = false;
  destinationMenuShown = false;
  activeSubMenu;
  faBars = faBars;

  hideResponsable: boolean = true;
  subscriptions: Subscription[] = [];
  @ViewChild('navbar') navbarElement!: ElementRef;
  @ViewChild('stickyTrigger') stickyTriggerElement!: ElementRef;
  private observer!: IntersectionObserver;
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: any,
    @Inject(DOCUMENT) private _doc: Document,
    private api: ApiService,
    private cache: LocalStorageCacheService,
    private renderer: Renderer2,
  ) {
    /*this._doc.addEventListener(
      'scroll',
      function () {
        const navBar = this.getElementById('navbar-menu');
        if (navBar) {
          if (this.defaultView.window.scrollY > 300) {
            navBar.classList.remove('fadeIn');
            this.getElementsByTagName('body')[0].classList.add('shrink');
            navBar.classList.add(
              'fixed-top',
              'animated',
              'fadeInDown',
              'black-backgound'
            );
          } else {
            navBar.classList.remove(
              'fadeInDown',
              'fixed-top',
              'black-backgound'
            );
            this.getElementsByTagName('body')[0].classList.remove('shrink');
            navBar.classList.add('animated', 'fadeIn');
          }
        }
      },
      { passive: true }
    );*/
  }
  ngAfterViewInit(): void {
    this.createObserver();
    // this.addChatwoot();
    if (isPlatformBrowser(this.platformId)) {
      this.addLiveHelperChat();
    }
  }
  ngOnInit(): void {
    const cachedData = this.cache.getItem('nav');

    if (cachedData) {
      this.continents = cachedData;
    }
    // Rafraîchi même quand le cache existe : il n'expire jamais, donc une
    // destination ajoutée en base (ex. USA Tours) n'apparaissait pas chez les
    // visiteurs déjà venus.
    const subscription = this.api.getContinents().subscribe((val) => {
      this.continents = val;

      this.cache.setItem('nav', val);
    });
    this.subscriptions.push(subscription);
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this._doc.defaultView.scrollTo(0, 0);
        }
      });
    }
  }

  /**
   * Destination de circuits (« USA Tours ») : le menu ouvre sa page Touring,
   * pas une liste d'hôtels. Seul son nom en base la distingue.
   */
  isTouringDestination(destination: any): boolean {
    return /\btours$/i.test(destination.destination);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  private createObserver() {
    const options = {
      root: null,
      threshold: 0,
    };
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          this.renderer.removeClass(this.navbarElement.nativeElement, 'sticky');
        } else {
          this.renderer.addClass(this.navbarElement.nativeElement, 'sticky');
        }
      }, options);

      this.observer.observe(this.stickyTriggerElement.nativeElement);
    }
  }

  addLiveHelperChat() {
    const script = document.createElement('script');
    script.text = `
    var LHC_API = LHC_API || {};
    LHC_API.args = {
        mode: 'widget',
        lhc_base_url: 'https://chat.luxuryholidaysdirect.com/',
        wheight: 450,
        wwidth: 350,
        pheight: 520,
        pwidth: 500,
        domain: '${new URL(environment.BASE_URL).hostname}',
        department: [1],
        leaveamessage: true,
        check_messages: false,
        theme: 1
    };

    (function() {
        var po = document.createElement('script');
        po.type = 'text/javascript';
        po.setAttribute('crossorigin', 'anonymous');
        po.async = true;
        // Refusé hors du domaine de production (CORS du serveur de chat, ex.
        // staging) ou bloqué : hors production, le pop-up d'accueil ouvre alors
        // le chat à part.
        po.onerror = function() { window.LHC_LOAD_FAILED = true; };
        var date = new Date();
        po.src = 'https://chat.luxuryholidaysdirect.com/design/defaulttheme/js/widgetv2/index.js?' +
                ("" + date.getFullYear() + date.getMonth() + date.getDate());

        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(po, s);

        // Observer pour détecter l'élément du widget
        const observer = new MutationObserver(() => {
            const element = document.querySelector('#lhc_status_widget_v2');

            if (element) {
            element.style.position='fixed';
                // element.style.bottom= '20px !important'
                // Décalé à gauche sur tous les appareils : le bouton WhatsApp
                // occupe le coin bas-droit.
                element.style.transform='translate(-86px, -10px)';
                element.style.cursor='pointer';
                element.style.zIndex='99999999';

                // console.log('Widget trouvé et repositionné :', element);
                observer.disconnect();
            }


            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

        })();

          `;
    document.body.insertAdjacentElement('beforeend', script);
  }

  sendMessageToWhatsApp(): void {
    // Lien court WhatsApp Business (+44 7404 604094)
    window.open('https://wa.me/message/MHOVR2ZXC2XCM1', '_blank');
  }
  getWhatsAppLink() {
    return '';
  }
  hideResponsableElement() {
    this.hideResponsable = false;
  }
}
